<template>
  <el-select v-model="value" v-on="$listeners" v-bind="$attrs" clearable filterable
             :multiple="multiple"
             v-loading="loading"
             :collapse-tags="!unCollapseTags"
             placeholder="执行公司">
    <el-option v-for="(item, index) in option"
               :key="index"
               :label="item.name"
               :value="item.id"
               :disabled="!history&&item.status!=='Y'"
    />
  </el-select>
</template>

<script>
import {getCustomerOption} from "@/api/customers";

export default {
  name: "ExecCorpSelect",
  props: {
    execCustomerId: {
      type: [Number, String, Array],
      default() {
        return null;
      }
    },
    unCollapseTags: Boolean,
    multiple: Boolean,
    history: Boolean,
  },
  computed: {
    value: {
      get() {
        return this.execCustomerId
      },
      set(val) {
        this.$emit('update:execCustomerId', val)
        let row = this.option.find(value => value.value === val)
        this.$emit('selected', row)
      }
    }
  },
  data() {
    return {
      option: [],
      loading: false,
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: async function () {
      this.loading = true;
      let exec_customer_id
      // if (this.projectType) {
      //   const {model} = await getCustomerOption()
      //   options = model.options || [];
      //   exec_customer_id = model.exec_customer_id
      // } else {
      //   const {data} = await getCustomerOption()
      //   options = data.options || [];
      // }
      const {model} = await getCustomerOption()

      this.option = model || [];
      this.loading = false;
      this.setDefaultExecCustomerId(exec_customer_id)
    },
    /**
     * 设置默认执行公司id
     * @param value
     */
    setDefaultExecCustomerId(value) {
      if (this.execCustomerId || !value) {
        return;
      }
      const tmp = this.option.find(option => {
        return parseInt(option.value) === parseInt(value)
      })
      if (tmp) {
        this.value = tmp.value
      }
    }
  }
}
</script>

<style scoped>

</style>
